import React from "react";
import "./GetStarted.css";
const GetStarted = () => {
  return (
    <div id="get-started" className="g-wrapper">
      <div className="paddings innerWidth g-container">
        <div className="flexColCenter inner-container">
          <span className="primaryText">Get started with SunSet Haven</span>
          <span className="secondaryText">
            Sign up for exclusive offers and discover unbeatable prices with us.
            <br />
            Your new home awaits.
          </span>
          <button className="button" href>
            <a href="mailto:nyabokeann99@gmail.com">Get Started</a>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GetStarted;
